var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._l((_vm.services),function(service,index){return _c('span',{key:service},[_c('router-link',{attrs:{"to":service}},[_vm._v(_vm._s(service))]),(index + 2 < _vm.services.length)?_c('span',[_vm._v(", ")]):_vm._e(),(index === _vm.services.length - 2)?_c('span',[_vm._v(" and ")]):_vm._e()],1)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dfb9e612","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/services-list.vue
// module id = null
// module chunks = 